import { Page } from '@dixa/lib-shared-habla';

import { ChatWidgets } from 'components/settings/components/sections/chat/chatWidgets';

export const SettingsChatView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head title="Chat" />

      <Page.Body>
        <ChatWidgets />
      </Page.Body>
    </Page>
  );
};
